import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';
import { createDataTable } from 'components/DataTable';
import React, { useState } from 'react';
import { BygrProjectDetails, ProjectMember } from 'types';
import { showModules } from 'utils/util';
// import theme from './ProjectMembers.module.scss';

interface ProjectMembersProps {
    project: BygrProjectDetails;
}
const MemberDataTable = createDataTable<ProjectMember>();

const ProjectMembers: React.FC<ProjectMembersProps> = ({ project }) => {
    const [memberTableState, setMemberTableState] = useState(MemberDataTable.getInitialState('userId'));

    return (
        <MemberDataTable
            hasPagination={false}
            data={project.members}
            onStateChange={setMemberTableState}
            state={memberTableState}
            totalItemCount={project.members.length}
            className="table style-3">
            <MemberDataTable.Column header="User Id" field="userId" renderer={({ value }) => value} />
            <MemberDataTable.Column
                header="User Name"
                field="userName"
                renderer={({ value, row }) => <CustomLink to={`/users/${row.userId}`}>{value}</CustomLink>}
            />
            <MemberDataTable.Column
                header="Profile"
                field="profileName"
                renderer={({ value, row }) => <CustomLink to={`/profiles/${row.profileId}`}>{value}</CustomLink>}
            />
            <MemberDataTable.Column header="Module" field="bygrModules" renderer={({ value }) => showModules(value)} />
            <MemberDataTable.Column header="Owner" field="isOwner" renderer={({ value }) => (value ? 'Yes' : 'No')} />
            <MemberDataTable.Column
                header="Cm Admin"
                field="isCmAdministrator"
                renderer={({ value }) => (value ? 'Yes' : 'No')}
            />
            <MemberDataTable.Column
                header="Am Admin"
                field="isAmAdministrator"
                renderer={({ value }) => (value ? 'Yes' : 'No')}
            />
            <MemberDataTable.Column
                header="Qm Admin"
                field="isQmAdministrator"
                renderer={({ value }) => (value ? 'Yes' : 'No')}
            />
        </MemberDataTable>
    );
};

export default ProjectMembers;
